import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index/Index.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Index',
        component: Index
    },
    // {
    //     path: '/:storeid/',
    //     name: 'Index',
    //     component: Index
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router


// const router = new VueRouter({
//     mode: 'history',
//     // mode: 'hash',
//     base: process.env.BASE_URL,
//     routes,
//     scrollBehavior(to, from, savedPosition) {
//         // always scroll to top
//         console.log(from.name + "->" + to.name);
//         if (savedPosition != null) {
//             console.log(savedPosition);
//         }

//         return { top: 0 }
//     },
// })

// export default router